var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43411 8.0678C6.44551 4.50869 7.4512 2.72912 8.83127 2.27104C9.59043 2.01903 10.4083 2.01903 11.1674 2.27104C12.5475 2.72912 13.5532 4.50869 15.5646 8.0678C17.576 11.6269 18.5817 13.4065 18.28 14.8565C18.114 15.6542 17.7051 16.3777 17.1119 16.9235C16.0335 17.9154 14.0222 17.9154 9.99935 17.9154C5.97656 17.9154 3.96516 17.9154 2.88682 16.9235C2.29359 16.3777 1.88468 15.6542 1.7187 14.8565C1.41701 13.4065 2.42271 11.6269 4.43411 8.0678Z",
    stroke: "#F03B3B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99414 13.332H10.0016",
    stroke: "#F03B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8334V7.5",
    stroke: "#F03B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.5470aa0305173bf5cb4b73842f585d81.svg";
export { ForwardRef as ReactComponent };